import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { register as registerSW } from "./serviceWorkerRegistration";

// ─── Fix: Radix UI + React 18 removeChild race condition ───
// Monkey-patch Node.prototype.removeChild to silently handle
// the case where a child has already been moved/removed by Radix portals.
const _origRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function (child) {
  if (child.parentNode !== this) {
    // The child was already removed or moved — skip silently
    console.debug("[Monyxx] Suppressed removeChild race:", child);
    return child;
  }
  return _origRemoveChild.call(this, child);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
registerSW();
